import axiosInstance from '../../../config/axiosInstance';
const JobService = {
    async GetAllJobs(redirectCallback, CustomerID, AssetID, StockID, ContractID, ProjectID, Start, PageSize, searchQuery, sortColumn, sortDirection, IsCompleted, columnsToSearch = "", selectedUser = 0) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Job/GetAllJobs?ClientID=${ClientID}
                &CustomerID=${CustomerID}&AssetID=${AssetID}
                &StockID=${StockID}&ContractID=${ContractID}&UserID=${UserID}
                &ProjectID=${ProjectID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}
                &sortColumn=${sortColumn}&sortDirection=${sortDirection}&IsCompleted=${IsCompleted}&SearchColumns=${columnsToSearch}&SelectedUser=${selectedUser}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetJobCount(redirectCallback, CustomerID, AssetID, StockID, ContractID, ProjectID, searchQuery, IsCompleted, columnsToSearch, selectedUser) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Job/GetJobCount?ClientID=${ClientID}
                &CustomerID=${CustomerID}&AssetID=${AssetID}
                &StockID=${StockID}&ContractID=${ContractID}&UserID=${UserID}
                &ProjectID=${ProjectID}&searchQuery=${searchQuery}&IsCompleted=${IsCompleted}
                &SearchColumns=${columnsToSearch}&SelectedUser=${selectedUser}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },


    async GetAllJobsMobile(redirectCallback, CustomerID, AssetID, StockID, ContractID, ProjectID, Start,
        PageSize, searchQuery, sortColumn, sortDirection, IssueStatusID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Job/GetAllJobsMobile?ClientID=${ClientID}
                &CustomerID=${CustomerID}&AssetID=${AssetID}
                &StockID=${StockID}&ContractID=${ContractID}&UserID=${UserID}
                &ProjectID=${ProjectID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}
                &sortColumn=${sortColumn}&sortDirection=${sortDirection}&IssueStatusID=${IssueStatusID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetJobCountMobile(redirectCallback, CustomerID, AssetID, StockID,
        ContractID, ProjectID, searchQuery, IssueStatusID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Job/GetJobCountMobile?ClientID=${ClientID}
                &CustomerID=${CustomerID}&AssetID=${AssetID}
                &StockID=${StockID}&ContractID=${ContractID}&UserID=${UserID}
                &ProjectID=${ProjectID}&searchQuery=${searchQuery}&IssueStatusID=${IssueStatusID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },



    async GetJobByID(redirectCallback, JobID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/GetJobByID?JobID=${JobID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetJobEnginners(redirectCallback, JobID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/GetEnginners?JobID=${JobID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetJobEnginnerTime(redirectCallback, UserID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/GetEnginnersTime?ClientID=${ClientID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteJob(redirectCallback, ID) {
        try {
            const idString = ID.join(',');
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/DeleteJob?ID=${idString}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteEngineerByID(redirectCallback, ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/DeleteEngineerByID?ID=${ID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async JobHistory(redirectCallback, JobID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/JobHistory?JobID=${JobID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async SetJobStatus(redirectCallback, JobID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/SetJobStatus?JobID=${JobID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async AddIssueCost(redirectCallback, formData) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.post(`/Job/AddIssueCost`, formData);
            return response.data.message;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async PurchasingJobs(redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/PurchasingJobs?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async TaskForDiaries(redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/TaskForDiaries?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async AppointmentsForDiaries(redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/AppointmentsForDiaries?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetSignature(IssueID) {
        try {
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Job/GetSignature?IssueID=${IssueID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetSignatureByJob(IssueID) {
        try {
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Job/GetIssueSignatureForJob?IssueID=${IssueID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async CreateSignature(formData) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem("UserID");
            formData.ClientID = ClientID;
            formData.UserID = UserID;
            const response = await axiosInstance.post(`/Job/CreateSignature`, formData);
            return response.data.message;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async LockJob(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Job/LockJob?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async UnLockJob(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Job/UnLockJob?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async GetEnginnerSignature(IssueID, UserID) {
        try {
            const response = await axiosInstance.get(`/Job/GetSignature?IssueID=${IssueID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async CompleteJob(IssueID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/CompleteJob?IssueID=${IssueID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async CreateTemplate(redirectCallback, JobID, templateName) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/CreateTemplate?JobID=${JobID}&ClientID=${ClientID}&TemplateName=${templateName}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetIssueTemplates() {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Job/GetIssueTemplates?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async CreateJobFromTemplate(JobID, ClientContactID, TimeToCall, CallTime) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');

            const response = await axiosInstance.get(`/Job/CreateJobFromTemplate?JobID=${JobID}&ClientID=${ClientID}&UserID=${UserID}&ClientContactID=${ClientContactID}&TimeToCall=${TimeToCall}&CallTime=${CallTime}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async UpdateJobStatusMobile(ID, Status) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Job/UpdateJobStatusMobile?ID=${ID}&Status=${Status}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async CreateEngineerTime(formData) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.post(`/Job/CreateEngineerTime`, formData);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    
};

export default JobService;